import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Soy desarrollador con más de 3 años de experiencia trabajando en
            frontend, backend y mobile. Me apasiona aprender constantemente y
            mejorar día a día, tanto a nivel técnico como profesional. He
            trabajado con tecnologías como Angular, React, Node.js, TypeScript,
            Python, Java, Django y MySQL, entre otras, y disfruto especialmente
            integrar APIs y construir soluciones que realmente resuelvan
            problemas reales para los usuarios. Para mí, escribir buen código
            significa que sea legible, mantenible y útil, no solo que funcione.
            Me adapto fácilmente a distintos equipos y entornos de trabajo, y
            valoro mucho la comunicación clara y la colaboración. Trabajo bien
            con metodologías ágiles como Scrum y Kanban, y disfruto los procesos
            de mejora continua.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
